export default __webpack_public_path__ + "static/media/south-korea.980c0746.png";